import { SET_DATA_KEY } from '../../../model/constants'
import updateSetWorkoutExerciseAction from '../update-set'
import { getCurrentSetWorkoutExerciseSelect } from '../../selectors/get-current-set'
import { updateWeightSetDataUtil } from '../../../model'

function updateSetWeightWorkoutExerciseAction (value) {
  return (dispatch, getState) => {
    const set = getCurrentSetWorkoutExerciseSelect(getState())
    dispatch(updateSetWorkoutExerciseAction({
      set: updateWeightSetDataUtil(set, value),
      key: SET_DATA_KEY.WEIGHT,
      shouldNotSave: true
    }))
  }
}

export { updateSetWeightWorkoutExerciseAction }
